<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.ibeaconSetting.setting') }}
        </div>

        <v-card>
            <v-card-text class="pb-1">
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            outlined
                            hide-details
                            height="40px"
                            append-icon="search"
                            v-model="search"
                            :placeholder="
                                $t('placeholder.filterByMacAddressAndName')
                            "
                        />
                    </v-col>
                    <v-col>
                        <i-beacon-map-view
                            v-model="mapDialog">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    outlined
                                    v-on="on"
                                    v-bind="attrs"
                                    class="float-right"
                                    color="primary">
                                    {{ $t('button.viewMap') }}
                                </v-btn>
                            </template>
                        </i-beacon-map-view>
                    </v-col>
                </v-row>
            </v-card-text>
            <i-beacon-list-view
                class="i-beacon-list-view"
                :ibeacons="ibeacons"
                :search="search"
                :pagination="pagination"
            />
        </v-card>

        <v-pagination
            v-show="showPagination"
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="page"
            :length="pageTotal"
            :total-visible="totalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import IBeaconListView from '@/views/lists/IBeaconListView'
import IBeaconMapView from '@/views/IBeaconMapView'
import PaginationMixin from '@/mixins/PaginationMixin'

import { mapState } from 'vuex'

export default {
    name: 'IBeaconListPage',

    mixins: [PaginationMixin],

    components: {
        IBeaconMapView,
        IBeaconListView
    },

    data () {
        return {
            mapDialog: false,
            search: '',
            sortBy: 'major',
            sortType: 'ASC'
        }
    },

    computed: {
        ...mapState('ibeacon', ['ibeacons', 'total'])
    },

    mounted () {
        this.fetchIBeacons()
    },

    methods: {
        fetchIBeacons () {
            this.$store.dispatch('ibeacon/fetchIBeacons', this.getQueryObject())
        },

        onPaginationChanged (value) {
            this.page = value
            this.fetchIBeacons()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
